import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MsalProvider } from '@azure/msal-react';
import Loader from '../components/Loader';
import { initializeRuntimeAuth } from './runtimeAuth';

export default function AuthBootstrap({ children }) {
  const [runtime, setRuntime] = useState(null);

  useEffect(() => {
    let active = true;
    initializeRuntimeAuth().then((value) => {
      if (active) setRuntime(value);
    });
    return () => {
      active = false;
    };
  }, []);

  if (!runtime) {
    return <Loader isLoading={true} />;
  }

  if (!runtime.instance) {
    return children;
  }

  return <MsalProvider instance={runtime.instance}>{children}</MsalProvider>;
}

AuthBootstrap.propTypes = {
  children: PropTypes.node.isRequired,
};
